module.exports = __webpack_public_path__ + "static/media/MIXLogo_HighRes.ab22f75a.png";